<template>
  <span>
    {{ data.value | currencyFormat }}
  </span>
</template>

<script>
import BaseDisplayType from './Base.vue'

export default {
  name: 'CurrencyDisplayType',
  extends: BaseDisplayType,
}
</script>

<style scoped>

</style>
